import { render, staticRenderFns } from "./QrReader.vue?vue&type=template&id=b20db8de&"
import script from "./QrReader.vue?vue&type=script&lang=js&"
export * from "./QrReader.vue?vue&type=script&lang=js&"
import style0 from "./QrReader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QrReader.vue"
export default component.exports